/* eslint-disable testing-library/render-result-naming-convention */
import { Button } from "reactstrap";

import styles from "components/ExportCsv/ExportCsv.module.css";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { format } from "date-fns";

const COLUMNS_TO_FORMAT_DATE = new Set(["start_time", "message_time"]);

export default function ExportCsv({
    headerTitles,
    rows,
    prepareRow,
}: {
    headerTitles: string[];
    rows: any;
    prepareRow: (row: any) => void;
}) {
    function downloadCsv(headerTitles: string[], rows: any) {
        if (!rows || rows?.length === undefined) return;

        const header = headerTitles.join(",");
        const csvRows = rows
            .map((row: any) => {
                prepareRow(row);
                const rowValues = row.cells.map((cell: any) => {
                    const content = cell.value;
                    let html =
                        typeof content === "string"
                            ? content
                            : getHtmlString(content);

                    if (COLUMNS_TO_FORMAT_DATE.has(cell.column.id)) {
                        html = format(new Date(html), "MMM d, HH:mm:ss ");
                    }

                    // Replace <div> ending tags with two line breaks
                    html = html.replace(/<pre>/g, "\n\n<pre>");

                    // Replace <a> tags with their inner text and two line breaks
                    let matches = html.matchAll(
                        /<a\s+href=['"]([^'"]+)['"][^>]*>(.*?)<\/a>/gim
                    );
                    html = Array.from(matches).reduce(
                        (acc, match) =>
                            acc.replace(match[0], match[1] + "\n\n"),
                        html
                    );

                    // Replace <br> tags with a single line break
                    html = html.replace(/<br\s*\/?>/g, "\n");

                    // Use DOMParser to strip remaining HTML tags
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    let text = doc.body.textContent || "";

                    // Escape double quotes by doubling them
                    text = text.replace(/"/g, '""');

                    // Wrap the entire cell value in double quotes
                    return `"${text}"`;
                });
                return rowValues.join(",");
            })
            .join("\n");
        const csv = `${header}\n${csvRows}`;

        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", "data.csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function getHtmlString(content: any) {
        const div = document.createElement("div");
        const root = createRoot(div);
        flushSync(() => {
            root.render(content);
        });
        return div.innerHTML;
    }

    return (
        <Button
            className={styles.exportBtn}
            onClick={() => downloadCsv(headerTitles, rows)}
        >
            Export CSV
        </Button>
    );
}
